"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var AlertLevels = exports.AlertLevels = {
  None: 0,
  Information: 1,
  Caution: 2,
  Critical: 3,
  Success: 4
};